import { useMemo } from 'react';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { checkbox_dark_theme } from '../constants';
import { CheckboxTheme, CheckboxThemePartial } from '../types';

export const useCheckboxTheme = (
  theme: CheckboxThemePartial = checkbox_dark_theme
): CheckboxTheme => {
  const {
    theme: {
      checkbox: { general, color },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      color: { ...color, ...theme.color },
    }),
    [theme, general, color]
  );
};
